<template>
  <el-select
    v-model="taxModel"
    @change="taxChanged"
    autocomplete="new-password"
    :placeholder="$t('COMMON.TAX')"
    :filterable="filterable"
    :multiple="multiple"
    :disabled="disabled"
    remote
    :remote-method="getTaxes"
    :loading="loading"
  >
    <el-option v-if="showAll" :value="null" :label="$t('COMMON.ALL_TAXES')">
    </el-option>
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')">
    </el-option>
    <el-option
      v-for="tax in taxes"
      :key="tax.id"
      :value="tax.id"
      :label="`${tax.name} (${tax.label})`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { cloneDeep } from "lodash";
import { Option, Select } from "element-ui";

export default {
  name: "tax-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
    tax: {
      type: String,
      default: null,
      description: "Tax id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterIdsNotIn: {
      type: Array,
      default: () => [],
      description: "Id not in",
    },
  },

  data() {
    return {
      taxModel: this.tax ?? null,
      taxes: {},
    };
  },

  setup() {},

  created() {
    this.getTaxes(null, this.tax);
  },

  methods: {
    async getTaxes(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          sort: "name",
          filter: {
            ...(query ? { search: encodeURIComponent(query) } : {}),
            ...(id ? { id: id } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }
        if (this.filterIdsNotIn.length > 0) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              idsNotIn: this.filterIdsNotIn,
            },
          };
        }

        await this.$store.dispatch("taxes/list", params);
        const taxesArr = await this.$store.getters["taxes/list"];
        this.taxes = {};
        taxesArr.forEach((tax) => {
          this.taxes[tax.id] = tax;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    taxChanged(taxId) {
      const taxData = cloneDeep(this.taxes[taxId]);
      this.$emit("taxChanged", taxId, taxData);
    },
  },

  watch: {
    tax(tax) {
      if (tax) {
        this.taxModel = tax;
        this.getTaxes(null, tax);
      } else {
        this.taxModel = null;
        this.getTaxes();
      }
    },
    filterOrganization(filterOrganization) {
      this.getTaxes();
    },
  },
};
</script>
